import useMount from '../useMount';

const useUpdateAppHeight = () => {
    useMount(() => {
        const updateAppHeight = () => {
            document.documentElement.style.setProperty('--app-height', `${window.innerHeight}px`);
        };

        updateAppHeight();
        window.addEventListener('resize', updateAppHeight);

        return () => {
            window.removeEventListener('resize', updateAppHeight);
        };
    });
};

export { useUpdateAppHeight };
